module.exports = __webpack_public_path__ + "static/scale-model-of-museum-of-the-southwest-in-midland-texas-8c3d912e75ad16dedf2af847cafddb01.png";